import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal,
} from 'react-bootstrap';
import CheckPermissions from '../../../../components/check-user-sync-permissions';

class CheckSyncPermissionModal extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.close = this.close.bind(this);
  }



  close() {
    this.props.onClose();
  }
  
  render() {
    const { show } = this.props;
    const {
      user, organization,
    } = this.props;
    const title = (
      <span>{user.display_name}</span>
    );
    return (
      <Modal key="modal" show={show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>Permissions Check for {title}</h4>
        </Modal.Header>
        <Modal.Body>
          <CheckPermissions
            organization={organization}
            user={user}
            showPermissionTable
            showErrors={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CheckSyncPermissionModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
  }).isRequired,
  user: PropTypes.shape({
    display_name: PropTypes.string,
  }).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
};
CheckSyncPermissionModal.defaultProps = {
  show: false,
  onClose: () => {},
};


export default CheckSyncPermissionModal;
